import RequestAbstract from "../abstract";

export default class PayoutAccounts extends RequestAbstract {
    data;
    constructor(data) {
        super(data);
        this.data = data;
        this.link = "api/payout-accounts";
    }
}
